export default "__VITE_ASSET__Df6gLoVJ__"